// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2BYzw"};